import React, { useEffect, useState } from "react";
import Overview from "./Overview";
import FaqPage from "./FAQ";
import Statistics from "./Statistics";
import Community from "./Community";
import CardScroller from "./IDOScroller";
import BackgroundScroller from "./IDOBackground";
import { contributeToFractionalNFT, getFractionalNFTFromContract, getFractionalNFTFromLocal, listActiveFractionalNFTs, redeemFractionalNFTFunds } from "../../../hooks/FNFThook";
import { useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ethers } from "ethers";
import { etherToGwei } from "../../../hooks/Tokenhook";
const listItems = ["Hot", "Games", "Design", "DtoC", "Blue"];

const listItemStyle = {
  backgroundColor: "#e6e6e7",
  color: "black",
  padding: "0.8rem",
  borderRadius: "10px",
  transition: "transform 0.3s, background-color 0.3s, color 0.3s",
};

const IDODetails = () => {
  const { id } = useParams();
  const [localFund, setLocalFund] = useState(null);
  const [contractFund, setContractFund] = useState(null);
  const [open, setOpen] = useState(false);
  const [openRedeem, setRedeem] = useState(false);

  const [contributionAmount, setContributionAmount] = useState("");
  const [tabs, setTabs] = useState([
    { index: 0, name: "Overview", active: true },
    { index: 1, name: "Statistics", active: true },
    { index: 2, name: "Community", active: true },
    { index: 3, name: "FAQ", active: true },
    { index: 4, name: "Offering", active: false },
  ]);

  const walletAddress = localStorage.getItem("WalletAddress");
  const PROVIDER = useSelector((state) => state.valueFromHeader);

  const [tabContents, setTabContents] = useState([
    { index: 0, name: "Overview", component: <Overview /> },
    { index: 1, name: "Statistics", component: <Statistics /> },
    { index: 2, name: "Community", component: <Community /> },
    { index: 3, name: "FAQ", component: <FaqPage /> },
    { index: 4, name: "Offering", component: <div>Offering Content</div> },
  ]);

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [newTabName, setNewTabName] = useState("");

  // Handle tab click
  const handleTabClick = (index) => {
    setActiveTabIndex(index);
  };
  const handleClose = () => {
    setOpen(false)
  }
  const handleOpen = () => {
    setOpen(true);
  }

  const handleOpenRedeem = () => {
    setRedeem(true)
  }
  const handleCloseRedeem = () => {
    setRedeem(false)
  }

  // Add a new tab with empty content
  const addNewTab = () => {
    if (newTabName.trim()) {
      setTabs([...tabs, { name: newTabName, active: false }]);
      setTabContents([
        ...tabContents,
        { name: newTabName, component: <div>{newTabName} Content</div> },
      ]);
      setNewTabName("");
    }
  };

  // Handle new tab name input
  const handleNewTabNameChange = (e) => {
    setNewTabName(e.target.value);
  };

  // Sidebar toggle for showing/hiding tabs
  const toggleTabVisibility = (index) => {
    const updatedTabs = tabs.map((tab, idx) =>
      tab.index === index ? { ...tab, active: !tab.active } : tab
    );

    setTabs(updatedTabs);
    if (activeTabIndex === index) {
      setActiveTabIndex(0);
    }
  };

  useEffect(() => {
    NFTData()
  }, [id]);

  const NFTData = async () => {
    const DatafromContract = await getFractionalNFTFromContract(id);
    if (DatafromContract.status === 200) {
      setContractFund(DatafromContract.data)
    }
    const params = {
      fractionNftId: id
    }
    const DatafromLocal = await listActiveFractionalNFTs(params);
    console.log("DatafromLocal", DatafromLocal);

    if (DatafromLocal.success) {
      setLocalFund(DatafromLocal.data[0])
    }
  }

  const RedeemCampaignPrice = async () => {
    if (contributionAmount !== null) {
      const FNFTId = localFund.fractionNftId;

      const body = {
        fractionalNftId: FNFTId,
      }
      redeemFractionalNFTFunds(body).then(async (data) => {
        console.log("data", data);
        const signer = await PROVIDER.getSigner(walletAddress);
        console.log("signer", signer);
        const sentTx = await signer.sendTransaction(data.data);
        console.log("sentTx", sentTx);

        const receipt = await sentTx.wait();
        console.log("receipt", receipt);

      })
    }
  }
  const contribute = async () => {
    try {
      if (!contributionAmount || isNaN(Number(contributionAmount))) {
        console.error("Invalid contribution amount");
        return;
      }

      const FNFTId = localFund?.fractionNftId;
      if (!FNFTId) {
        console.error("Fraction NFT ID is missing");
        return;
      }

      // const fund = etherToGwei(contributionAmount).toString();
      const fund = contributionAmount.toString();
      const body = {
        fractionalNftId: FNFTId,
        contributionAmount: fund,
      };

      console.log("Submitting contribution:", body);

      const response = await contributeToFractionalNFT(body);
      if (!response?.data) {
        console.error("Invalid API response", response);
        return;
      }

      console.log("API Response:", response, response.data, response.data.data);

      const signer = await PROVIDER.getSigner(walletAddress);
      if (!signer) {
        console.error("Signer not found");
        return;
      }

      console.log("Signer obtained:", signer);

      const sentTx = await signer.sendTransaction(response.data);
      console.log("Transaction sent:", sentTx);

      const receipt = await sentTx.wait();
      console.log("Transaction receipt:", receipt);
    } catch (error) {
      console.error("Error in contribute function:", error);
    }
  };

  // console.log("At IDO Details => contractFund, localFund", contractFund, localFund);

  console.log("at IDO Details => contractFund, localFund", contractFund, localFund, localFund !== null && contractFund.nftOwner === walletAddress);

  return (
    <>
      <div className="">

        <div
          // className="bg-white"
          style={{
            borderRadius: "18px",
          }}
        >
          <BackgroundScroller localData={localFund} />
        </div>
        <div className="container">
          {localFund?.nftOwner !== walletAddress ?
            <div className="btn btn-lg btn-dark float-right" onClick={handleOpen}>
              Contribute
            </div>
            :
            <div className="btn btn-lg btn-dark float-right" onClick={handleOpenRedeem}>
              Redeem
            </div>
          }
        </div>
        <div className="mt-2 container" style={{ display: "flex" }}>
          {/* Sidebar */}

          <div
            className="m-2 p-3"
            style={{ width: "220px", borderRadius: "20px", background: "white" }}
          >
            <h3>Manage Tabs</h3>
            <hr style={{ marginTop: "10px" }} />
            {tabs.map((tab, index) => (
              <div key={index} style={{ marginBottom: "10px" }}>
                {tab.index === 0 ? (
                  <span style={{ marginLeft: "13px" }}></span>
                ) : (
                  <input
                    type="checkbox"
                    checked={tab.active}
                    onChange={() => toggleTabVisibility(tab.index)}
                    style={{ marginRight: "5px", zoom: "50px" }}
                  />
                )}
                {tab.name}
              </div>
            ))}

            <div style={{ marginTop: "20px" }}>
              <input
                type="text"
                value={newTabName}
                onChange={handleNewTabNameChange}
                placeholder="New Tab Name"
                style={{ padding: "5px", marginBottom: "10px", width: "100%" }}
              />
              <button
                onClick={addNewTab}
                style={{
                  backgroundColor: "#d63333",
                  color: "#fff",
                  border: "none",
                  padding: "4px",
                  cursor: "pointer",
                  borderRadius: "7px",
                  height: "34px",
                  // width: "100%",
                }}
              >
                Add Tab
              </button>
            </div>
          </div>

          {/* Main Tab Area */}
          <div
            className="bg-white p-2 m-2"
            style={{ flex: 1, borderRadius: "20px" }}
          >
            {/* Tab Headers */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                borderBottom: "1px solid #c5ced5",
              }}
            >
              {tabs
                .filter((tab) => tab.active)
                .map((tab, index) => (
                  <div
                    key={index}
                    onClick={() => handleTabClick(tab.index)}
                    style={{
                      padding: "10px 20px",
                      cursor: "pointer",
                      position: "relative",
                      color: activeTabIndex === index ? "#d63333" : "#183b56",
                    }}
                  >
                    {tab.name}
                    {activeTabIndex === index && (
                      <div
                        style={{
                          height: "2px",
                          backgroundColor: "#d63333",
                          position: "absolute",
                          bottom: "0",
                          left: "0",
                          right: "0",
                        }}
                      />
                    )}
                  </div>
                ))}
            </div>

            {/* Tab Content */}
            <div style={{ padding: "20px" }}>
              {tabContents[activeTabIndex]?.component}
            </div>
          </div>
        </div>

        <div className="container m-5">
          <h3>Tags for this project</h3>
          <ul className="d-flex flex-row p-3 list-group gap-lg-5">
            {listItems.map((item, index) => (
              <li
                key={index}
                style={listItemStyle}
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.1)";
                  e.target.style.backgroundColor = "#d0d0d1";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.backgroundColor = "#e6e6e7";
                  e.target.style.color = "black";
                }}
              >
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-4">
            <h2 className="mb-4">You may also be interested in</h2>
            <CardScroller />
          </div>
        </div>
      </div>
      <Modal
        show={open}
        size="lg"
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Contribute</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Add Contribution Amount </h4>
          <p>
            <input
              type="number"
              className="mt-2"
              placeholder="0"
              onChange={(e) => setContributionAmount(e.target.value)}
              min="0"
            />{" "}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseRedeem}>Cancal</Button>
          <Button onClick={contribute}>Contribute</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openRedeem}
        size="lg"
        onHide={handleCloseRedeem}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Redeem</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2>Are you sure for Redeem ?? </h2>
          {/* <p>
            <input
              type="number"
              onChange={(e) => setContributionAmount(e.target.value)}
              min="0"
            />{" "}
          </p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCloseRedeem}>Cancal</Button>
          <Button onClick={RedeemCampaignPrice}>Redeem</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default IDODetails;
